import reducer from "./reducer";
export { default as HistoricalProcesses } from "./components/index";
export { default as historicalProcessesReducerName } from "./constants";
export default reducer;
